export const REDUCER_NAME = "competitionNews";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONNEWS = `${REDUCER_NAME}/SET_COMPETITIONNEWS`;
export const RESET_COMPETITIONNEWS = `${REDUCER_NAME}/RESET_COMPETITIONNEWS`;

export const getKey = (data) => `${data.isFeatured || false}`;
